import { EyeArrowLeftIcon } from './EyeArrowLeftIcon';

/**
 * author: Michael Irigoyen
 * id B3FA5237-3FE4-4822-87EE-0001DD784EE7
 * name eye-arrow-left
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-arrow-left.svg
 * tags
 */
export const ViewArrowLeftIcon = EyeArrowLeftIcon;
export default ViewArrowLeftIcon